<template>
    <div class="">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

            </div>
        </div>

        <div class="row mt-4 no-margin">
            <div class="ibox col-md-12">
                <div class="ibox-title dashboard_title px-0">
                    <h4 class="font-regular with-blue-text">Current Selected: <span>Annual Tax Deducted at Source (TDS) Report</span></h4>
                </div>
                <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3">
                    <div class="d-inline-block trz_fields trz-custom-dropdown" >
                        <b-dropdown id="dropdown-fields"  text="Select Additional Fields" ref="dropdown" class="mb-1 position-relative">
                            <b-dropdown-form>
                                <b-form-group @submit.stop.prevent>
                                    <div class="form-group">
                                        <b-form-checkbox-group
                                            v-model="column_selected"
                                            :options="column_options"
                                            switches

                                        />
                                    </div>
                                    <button type="button" @click="setcolumn()" class="btn btn-primary d-none">Save</button>
                                </b-form-group>
                            </b-dropdown-form>
                        </b-dropdown>
                    </div>
                    {{clickSelect}}
                    <div class="d-inline-block report-selected-columns" v-if="column_selected_view.length > 0"> <span class="font-semi-bold text-secondary py-1 px-2 bg-white rounded" v-for="column in column_selected_view">{{ stringView(column) }}</span></div>
                </div>
            </div>


            <div class="ibox col-md-12">
                    <div class="ibox-content px-0 pt-3">
                    <table class="table">
                        <thead>
                            <tr class="table-head">
                            <th scope="col">Fiscal Year</th>
                            <th scope="col">Preview Report</th>
                            <th scope="col">Download Excel</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="display: none;"></tr>
                            <tr class="table-row hover-bg" v-for="(data, n) in payroll_reporting_data" :key="n">
                                <td>{{data.fiscal_year}}</td>
                                <td><a href="#" @click="viewDetails(data.fiscal_year)"><i class="fas fa-list"> </i> Preview Report</a></td>
                                <td><a href="#" @click="getSalaryReport(data.fiscal_year)"><i class="far fa-file-excel"> </i> Download Report (Excel)</a></td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <b-modal id="tds-payroll-report" dialog-class="modal-xxl" size="xl" scrollable  hide-footer title="Annual Tax Deducted at Source (TDS) Report">
            <b-overlay rounded="sm">
                <!-- alpha fix- removed border-bottom  -->
                <div class="clearfix row py-2 mb-2 ">
                    <div class="col-md-6 px-3 company-form-box-title">{{fiscal_year}}</div>
                    <div class="col-md-6">
                        <b-input-group class="mb-0 custom-search ml-auto mr-0">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>

                <table class="table ">
                    <thead class="" style="">
                        <tr class="table-head"  v-for="(detail, index) in paginatedData" :key="detail.employee_ID">
                            <template v-if="index < 1">
                                <td class="text-center" v-for="(v,i,count) in detail">{{ replaceTableHeads(i) }}</td>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="display: none;"></tr>
                        <tr class="table-row hover-bg" v-for="detail in paginatedData" :key="detail.employee_ID">
                            <!--aboni 10-11-21-->
                            <template v-for="(v,i,count) in detail">
                                <td v-if="column_selected.indexOf(stringViewReverse(i)) !== -1 || column_selected.indexOf(i) !== -1">{{v}}</td>
                                <td v-else-if="i == 'Name Of Employee' || i == 'Job Position' || i == 'details'">{{v}}</td>
                                <td v-else class="text-right">{{v}}</td>
                            </template>
                            <!--aboni 10-11-21-->
                        </tr>
                    </tbody>
                </table>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{empty_result}}</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next"  base-url="#" first-number last-number ></b-pagination-nav></div>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>


    export default{

        mounted() {
            this.$refs.trzcalendar;
        },
        props: [ 'flag'],
        components: {

        },
        data(){

            return {



                search:'',
                length: 100,
                pagination: {currentPage: 1, pages:1},

                empty_result : 'Please hold tight! We are preparing the report data for you!',

                fiscal_year : '',

                payroll_reporting_data : [],
                details : [],
                showoverlay : true,
                loader: false,
                /***Ali */
                column_selected:[],
                column_options:[],
                default_fields:[],
                column_selected_view:[],
                show_selected:'',

            }
        },
        methods:{

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            getPayrollReporting: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting' , {
                    params: {

                    }
                }).then(function(response){
                    this.payroll_reporting_data = response.data;
                    //console.log(this.payroll_reporting_data);

                }.bind(this));
            },
            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');

                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    if(val[i].length == 2 && val[i] == 'pf'){
                        val[i] = val[i].toUpperCase();
                    }else{
                        val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);
                    }
                }
                return val.join(' ');
            },
            viewDetails: function(year)
            {
                if(!this.checkNet()) return false;
                var months = ["", "January", "February", "March", "April", "May", "June",
           "July", "August", "September", "October", "November", "December" ];

                this.fiscal_year = year;

                if(this.column_selected.indexOf('name') === -1){
                    this.column_selected.unshift('name');
                }

                let formData = new FormData();
                formData.append('fiscal_year', year);
                formData.append('report_name', 'tds');
                formData.append('column_selected', this.column_selected);
                let url = this.$api_url + '/payroll-custom-report-data';
                let currentObj = this;
                this.details = [];
                axios.post(url, formData).then(function (response)
                {
                    this.empty_result = 'Please hold tight! We are preparing the report data for you!';
                    this.details = response.data;

                    if(this.details.length == 0)
                        this.empty_result = 'No Result Found!';

                }.bind(this)).catch(function (error){ currentObj.serverError(error);});

                this.$bvModal.show('tds-payroll-report');


            },
            getSalaryReport: function(fiscal_year)
            {
                if(!this.checkNet()) return false;
                this.loader = true;

                if(this.column_selected.indexOf('name') === -1){
                    this.column_selected.unshift('name');
                }
                let formData = new FormData();
                formData.append('fiscal_year', fiscal_year);
                formData.append('grid_report', 'Excel');
                formData.append('report', 1);
                formData.append('column_selected', this.column_selected);
                const config = {
                    headers: { 'Content-Type': 'application/json; charset=utf-8', },
                    responseType: 'blob',
                }
                let url = this.$api_url + '/income_tax_report_custom';

                axios.post(url, formData, config).then(function (response)
                {
                    //this.payroll_reporting_data = response.data;
                    //console.log(response.data);
                    //var fileURL = this.$api_url+'/income_tax_report?grid_report=Excel&fiscal_year='+fiscal_year;
                    // var fileURL = response.data;
                    // this.download_file(fileURL);
                    this.loader = false;
                    if(response.data.type =='application/json'){
                        let file = new Blob([response.data], {type: 'application/json'});
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                        });
                    }else{
                        this.global_download_file_content(response);
                    }

                }.bind(this))
                .catch(error => {
                    if(error.response){
                        this.loader = false;
                    }
                });
                return false;
            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            getPayrollDefaultField()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting/defaultfields' , {
                }).then(function(response){
                    this.default_fields = response.data;
                    let available_colunms = [];

                    let co = [];
                    var txt = '';
                    this.default_fields.forEach(element => {

                        if(element=='etin')
                        {
                            txt = 'e-TIN';
                        }
                        else if(element=='jobposition')
                        {
                            txt = 'Job Position';
                        }
                        else if(element=='nid')
                        {
                            txt = 'NID';
                        }
                        else if(element=='branch')
                        {
                            txt = 'Work Location';
                        }
                        else
                        {
                            txt = this.stringView(element);
                        }
                        co = co.concat([{ text: txt , value: element }]);



                        available_colunms = available_colunms.concat(element);
                    });

                    this.column_options = this.column_options.concat(co);


                    // console.log('available_colunms');

                    // console.log(available_colunms);

                    // console.log('column_selected');

                    // console.log(this.column_selected);

                    let final_column_selected = [];
                    this.column_selected.forEach(element =>
                    {
                        if(available_colunms.includes(element))
                        {
                            // console.log('available_colunms_element');
                            // console.log(element);
                            final_column_selected.push(element);
                        }
                        else
                        {
                            // console.log('available_colunms_missing');
                            // console.log(element);
                            // //this.column_selected.splice(this.column_selected.lastIndexOf(element), 1);
                        }
                    });


                    // console.log('final_column_selected');
                    // console.log(final_column_selected);

                    this.column_selected = final_column_selected;

                    // console.log('column_selected');
                    // console.log(this.column_selected);

                }.bind(this));
            },
            stringView(str)
            {
                if(str == 'jobposition')
                    str = 'job_position';
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            stringViewReverse(str)
            {
                if(str == 'jobposition')
                    str = 'job_position';

                str = str.replace(/ /g,"_").toLowerCase();

                return str;
            },
            setcolumn: function()
            {
                this.$cookies.set("report_column_selected", this.column_selected);

                this.$refs.dropdown.hide(true);
            },
            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            }

        },
        created: function(){
            if(this.$cookies.isKey("report_column_selected"))
            {
                if(this.$cookies.get("report_column_selected") != null && this.$cookies.get("report_column_selected") != '')
                {
                    if(Array.isArray(this.$cookies.get("report_column_selected")))
                    {
                        this.column_selected = this.$cookies.get("report_column_selected");
                    }
                    else
                    {
                        this.column_selected = this.$cookies.get("report_column_selected").split(',');
                    }
                }
            }
            // End: Mustafijur : 8-24-25 Cookie

            this.getPayrollDefaultField();
            this.fiscal_year = this.getCurrentFinancialYear();
            this.getPayrollReporting();
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.details;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
            clickSelect()
            {
                var lt = this.column_selected_view.length;

                this.column_selected_view = this.column_selected;
                if(this.column_selected_view.length !=  lt)
                {
                    this.column_selected_view = this.column_selected;
                }

                // if(this.column_selected.indexOf('name') > -1){
                //     this.column_selected.splice('name', 1);
                // }
                this.show_selected = this.column_selected_view.join();
                this.show_selected = this.show_selected.replaceAll("_", " ");
                this.show_selected = this.show_selected.replaceAll(",", " , ");
                this.show_selected = this.capitalizeTheFirstLetterOfEachWord(this.show_selected);

                if(this.column_selected.length ==0)
                {
                    this.show_selected = 'None Selected';
                }

                this.$cookies.set("report_column_selected", this.column_selected,'24h');

            },

        }
    }
</script>
